// extracted by mini-css-extract-plugin
module.exports = {"main-component":"featureSwim_main-component__2i_mD"};